import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TabSessionState, tabSessionFeatureKey } from './tab-session.reducer';

export const selectTabSessionState = createFeatureSelector<TabSessionState>(tabSessionFeatureKey);

export const selectTabSessions = createSelector(
    selectTabSessionState,
    (state: TabSessionState) => state.tabSessions
);